import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '$lib/hooks/useTheme';
import { cn } from '$lib/lib/cn';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();
  const next = theme === 'light' ? 'dark' : 'light';
  const label = t('theme.switchTo', { theme: t(next === 'dark' ? 'theme.dark' : 'theme.light') });
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={cn(
        'grid h-8 w-8 place-items-center rounded-sm border border-rule-strong bg-surface text-fg-muted',
        'hover:bg-surface-2 hover:text-fg transition-colors duration-fast',
        className
      )}
    >
      {theme === 'light' ? <Moon size={14} /> : <Sun size={14} />}
    </button>
  );
}
